var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m25.0312 27.1768.1767.1768.1768-.1768 1.8-1.8.1768-.1768-.1768-.1768-6.8842-6.8842a10.8633 10.8633 0 0 0 1.8874-9.019 10.8637 10.8637 0 0 0-5.9183-7.3219 10.8635 10.8635 0 0 0-9.4145.0497l.1089.2234-.1089-.2234a10.8645 10.8645 0 0 0-5.8406 7.3839 10.8647 10.8647 0 0 0 2.1194 9.1731 10.8633 10.8633 0 0 0 8.4879 4.0731l.1396-.0001.0005-.0008a10.8093 10.8093 0 0 0 6.3855-2.184l6.8838 6.8838ZM11.6217 3.797a7.8172 7.8172 0 0 1 7.8169 7.8166 7.817 7.817 0 0 1-7.8169 7.8168 7.8164 7.8164 0 0 1-7.8165-7.8168 7.8166 7.8166 0 0 1 7.8165-7.8166Z","fill":"currentColor","stroke":"currentColor","strokeWidth":".5"}));
}

Search.defaultProps = {"fill":"none","viewBox":"0 0 28 28"};

module.exports = Search;

Search.default = Search;
